import api from 'Application/api/api';

const deleteProject = (id, cancelToken = null) =>
    api.delete(`project-manager/projects/${id}`, { cancelToken });

export default deleteProject;
